import { render, staticRenderFns } from "./secondPicture.vue?vue&type=template&id=6da2a364&scoped=true&"
import script from "./secondPicture.vue?vue&type=script&lang=js&"
export * from "./secondPicture.vue?vue&type=script&lang=js&"
import style0 from "./secondPicture.vue?vue&type=style&index=0&id=6da2a364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da2a364",
  null
  
)

export default component.exports